import type { DocumentTypeConfig } from "../types";

export const impactConfig: DocumentTypeConfig = {
  documentType: "impact",
  supportedFormats: ["xlsx", "pdf"],
  xlsx: {
    version: {
      cell: "M7",
      sheetName: "Instrucțiuni de utilizare",
      sheetIndex: 0,
      expectedVersions: ["1.0"],
    },
    sheets: [
      {
        sheetName: "Analiză efect perturbator",
        sheetIndex: 1,
        mappings: [
          {
            cell: "C10",
            field: "denumire_entitate",
            valueType: "string",
            required: true,
          },
          { cell: "C11", field: "cui", valueType: "string", required: true },
          {
            cell: "D15",
            field: "is_sole_essential_provider",
            valueType: "string",
            required: false,
          },
          {
            cell: "B16",
            field: "is_sole_essential_provider_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D17",
            field: "formally_designated",
            valueType: "string",
            required: false,
          },
          {
            cell: "B18",
            field: "formally_designated_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D27",
            field: "personal_data_affected",
            valueType: "number",
            required: false,
          },
          {
            cell: "B28",
            field: "personal_data_affected_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D29",
            field: "public_service_access_lost",
            valueType: "number",
            required: false,
          },
          {
            cell: "B32",
            field: "public_service_access_lost_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D34",
            field: "gdp_loss_over_threshold",
            valueType: "string",
            required: false,
          },
          {
            cell: "B35",
            field: "gdp_loss_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D36",
            field: "affects_other_sector_services",
            valueType: "string",
            required: false,
          },
          {
            cell: "B37",
            field: "affects_other_sector_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D38",
            field: "highest_sector_impact_percentage",
            valueType: "number",
            required: false,
          },
          {
            cell: "B39",
            field: "highest_sector_impact_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D40",
            field: "affects_critical_infrastructure",
            valueType: "string",
            required: false,
          },
          {
            cell: "B41",
            field: "affects_critical_infrastructure_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D43",
            field: "can_cause_death",
            valueType: "string",
            required: false,
          },
          {
            cell: "B44",
            field: "can_cause_death_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D45",
            field: "chronic_illness_or_disability",
            valueType: "number",
            required: false,
          },
          {
            cell: "B46",
            field: "chronic_illness_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D47",
            field: "traumatic_injuries_or_health_impact",
            valueType: "number",
            required: false,
          },
          {
            cell: "B48",
            field: "traumatic_injuries_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D50",
            field: "people_financial_loss",
            valueType: "number",
            required: false,
          },
          {
            cell: "B51",
            field: "financial_loss_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D53",
            field: "affects_defense_capacity",
            valueType: "string",
            required: false,
          },
          {
            cell: "B54",
            field: "defense_capacity_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D55",
            field: "generates_state_incapacity",
            valueType: "string",
            required: false,
          },
          {
            cell: "B56",
            field: "state_incapacity_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D57",
            field: "damages_state_reputation",
            valueType: "string",
            required: false,
          },
          {
            cell: "B58",
            field: "reputation_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D60",
            field: "affects_other_sectors",
            valueType: "string",
            required: false,
          },
          {
            cell: "B61",
            field: "affects_other_sectors_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D62",
            field: "affected_sectors_count",
            valueType: "number",
            required: false,
          },
          {
            cell: "D63",
            field: "highest_impact_percentage",
            valueType: "number",
            required: false,
          },
          {
            cell: "B64",
            field: "impact_percentage_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D65",
            field: "affects_international_obligations",
            valueType: "string",
            required: false,
          },
          {
            cell: "B66",
            field: "international_obligations_explanation",
            valueType: "string",
            required: false,
            stripLabelPrefix: true,
          },
          {
            cell: "D71",
            field: "result_9a",
            valueType: "string",
            required: false,
          },
          {
            cell: "D72",
            field: "result_9b",
            valueType: "string",
            required: false,
          },
          {
            cell: "D73",
            field: "result_9c",
            valueType: "string",
            required: false,
          },
          {
            cell: "D74",
            field: "result_9d",
            valueType: "string",
            required: false,
          },
          {
            cell: "D78",
            field: "rep_prenume",
            valueType: "string",
            required: false,
          },
          {
            cell: "D79",
            field: "rep_nume",
            valueType: "string",
            required: false,
          },
          {
            cell: "D80",
            field: "rep_functia",
            valueType: "string",
            required: false,
          },
        ],
      },
    ],
  },
};
